import { throttle, defer } from 'lodash-es';
import Component from 'navigation/component/Component';
import mqStore from 'store/mqStore';
import scroll from 'core/scroll';
import { dimensions } from 'helpers/resize';
import store from 'store';
import sizeStore from 'store/sizeStore';
class ProductGallery extends Component {
    bounds;
    thumbFollowHeight;
    small = false;
    constructor(el, options) {
        super(el, options);
        this.thumbFollowHeight = 0;
    }
    initialized() {
        super.initialized();
        this.small = this.el.classList.contains('small');
        if (this.refs.thumbItems)
            this.onScroll();
        const thumbVideo = this.refs.trackItems?.find(item => item.querySelector('video'));
        if (thumbVideo) {
            const videoEl = thumbVideo.querySelector('video');
            videoEl.setAttribute('preload', 'metadata');
        }
    }
    bindEvents(add = true) {
        const m = add ? 'addEventListener' : 'removeEventListener';
        if (this.refs.zoomItem)
            scroll[add ? 'on' : 'off'](this.onScroll);
        if (this.refs.zoomItem)
            this.refs?.zoomItem.forEach((item, index) => item[m]('click', this.onOpenZoom(index)));
        if (this.refs.thumbItems)
            this.refs?.thumbItems[m]('click', this.onThumbClick);
        if (this.refs.shopLookButton)
            this.refs.shopLookButton[m]('click', this.onShopLookClick);
        if (this.refs.list)
            this.refs.list[m]('scroll', this.onScrollMobile);
        window[m]('keyup', this.onKeyPress);
    }
    onOpenZoom = (index) => () => {
        this.options.parent.modules.zoom.open(index);
        this.resize();
    };
    onKeyPress = (event) => {
        if (event.key === 'Escape') {
            this.options.parent.modules.zoom.onClose();
            this.resize();
        }
    };
    onThumbClick = (event) => {
        const mouseEvent = event; // Cast event to MouseEvent
        const thumbClickPosition = mouseEvent.clientY - (this.refs.thumbItems.getBoundingClientRect().top);
        const thumbClickRatio = thumbClickPosition / this.refs.thumbItems.scrollHeight;
        if (this.refs.list) {
            const scrollTarget = thumbClickRatio * this.refs.list.scrollHeight - dimensions().innerHeight / 2;
            scroll.scrollTo(scrollTarget);
        }
    };
    onScroll = throttle(() => {
        if (mqStore.tabletPortrait.get())
            return;
        defer(() => {
            if (!this.refs.list)
                return;
            const scrollableHeight = this.refs.list.scrollHeight;
            const scrollY = scroll.scrollTop();
            const thumbTop = (scrollY / scrollableHeight) * 100;
            const thumbFollowHeightPercentage = (this.thumbFollowHeight / this.refs.thumbItems.scrollHeight) * 100;
            const adjustedThumbTop = Math.min(thumbTop, 100 - thumbFollowHeightPercentage);
            const trackWrapperHeightRatio = this.refs.thumbItems.scrollHeight / this.refs.thumbItems.clientHeight;
            this.refs.track.style.setProperty('--zoom-thumb-top', `${adjustedThumbTop * trackWrapperHeightRatio}%`);
            this.refs.thumbItems.scrollTo(0, adjustedThumbTop * (trackWrapperHeightRatio + 2));
        });
    });
    onScrollMobile = () => {
        const progress = this.refs.list.scrollLeft / (this.refs.list.scrollWidth - this.refs.list.clientWidth);
        this.refs.trackMobile.style.transform = `translateX(${progress * (100) * (this.refs.galleryItems.length - 1)}%)`;
    };
    onShopLookClick = () => {
        store.drawer.set('shop-the-look');
    };
    resize() {
        super.resize();
        defer(() => {
            const inc = sizeStore.notificationHeight.get() + sizeStore.headerHeight.get();
            this.bounds = this.refs.galleryItems.map(item => inc + item.offsetTop + (item.offsetHeight / 2));
            this.bounds.pop();
            this.bounds.unshift(0);
            const wrapperHeight = this.refs.list?.scrollHeight - 25;
            const vh = window.innerHeight;
            const wrapperThumbHeight = this.refs.thumbItems?.scrollHeight;
            this.thumbFollowHeight = (wrapperThumbHeight * vh) / wrapperHeight;
            this.refs.track?.style.setProperty('--zoom-thumb-height', `${this.thumbFollowHeight}px`);
            this.refs.track.style.opacity = '0.3';
        });
    }
    flush() {
        super.flush();
    }
}
export default ProductGallery;
